// FIXME: add to @geoblocks/sources ?

import WMSSource from 'ol/source/TileWMS.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import {getTopLeft} from 'ol/extent.js';
import {proj as epsg2056} from '@geoblocks/proj/src/EPSG_2056.js';
import type {Options as WMTSOptions} from 'ol/source/WMTS';
import {RESOLUTIONS} from '../constants.ts';
import {getInitialSearchParams} from '../../urlHandling/urlSearchParams.ts';
import {getLanguageCode} from '../../i18n.ts';

type ImageExtension = 'jpeg' | 'png';

export const swisstopoWMSTileGrid = new TileGrid({
  origin: getTopLeft(epsg2056.getExtent()),
  extent: epsg2056.getExtent(),
  resolutions: RESOLUTIONS,
});

export default class SwisstopoWMS extends WMSSource {
  constructor(
    layer: string,
    timestamp: string,
    extension: ImageExtension,
    options?: Partial<WMTSOptions>,
  ) {
    let tilePixelRatio = 1;
    let zDirection = 0;

    const params = getInitialSearchParams();
    if (devicePixelRatio > 1) {
      tilePixelRatio = params.has('tilePixelRatio')
        ? parseInt(params.get('tilePixelRatio'))
        : 2;
      zDirection = params.has('zDirection')
        ? parseInt(params.get('zDirection'))
        : -1;
    }

    super(
      Object.assign(
        {
          url: 'https://wms.geo.admin.ch',
          params: {
            LAYERS: 'ch.vbs.schiessanzeigen',
            REQUEST: 'GetMap',
            VERSION: '1.3.0',
            FORMAT: 'image/png',
            TRANSPARENT: 'true',
            CRS: 'EPSG:2056',
            LANG: getLanguageCode(),
          },
          projection: epsg2056,
          tileGrid: swisstopoWMSTileGrid,
          transition: 0,
          tilePixelRatio: tilePixelRatio,
          zDirection: zDirection,
          crossOrigin: 'anonymous',
        },
        options,
      ),
    );
  }
}
